var _rect, _rect2, _rect3, _rect4, _rect5, _rect6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBoxes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "boxesWelcome",
    width: 360,
    height: 70,
    viewBox: "0 0 95.249998 18.520833",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-58.301 -176.68)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "box",
    x: 58.301,
    y: 176.68,
    width: 17.198,
    height: 18.521,
    fill: "#2a44bb"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "box",
    x: 74.455,
    y: 176.68,
    width: 15.875,
    height: 18.521,
    fill: "#2a44bb"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "box",
    x: 90.19,
    y: 176.68,
    width: 19.844,
    height: 18.521,
    fill: "#2a44bb"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "box",
    x: 105.79,
    y: 176.68,
    width: 15.875,
    height: 18.521,
    fill: "#2a44bb"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "box",
    x: 121.52,
    y: 176.68,
    width: 17.198,
    height: 18.521,
    fill: "#2a44bb"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "box",
    x: 137.15,
    y: 176.68,
    width: 16.404,
    height: 18.521,
    fill: "#2a44bb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "welcome",
    transform: "matrix(1.0346 0 0 1.0346 -3.6701 -8.7476)",
    fill: "#000000",
    strokeWidth: ".25241px",
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    },
    "aria-label": "welcome"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m66.239 185h1.6328l2.0409 7.7556 2.0321-7.7556h1.9256l2.0409 7.7556 2.0321-7.7556h1.6328l-2.6 9.9385h-1.9256l-2.1386-8.146-2.1474 8.146h-1.9256z",
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m90.561 189.56v0.79864h-7.5071q0.10648 1.686 1.0116 2.5734 0.91399 0.87849 2.5379 0.87849 0.94061 0 1.8191-0.23071 0.88737-0.23072 1.757-0.69215v1.544q-0.87849 0.37269-1.8014 0.56792-0.92286 0.19522-1.8723 0.19522-2.3781 0-3.7713-1.3843-1.3843-1.3843-1.3843-3.7447 0-2.4403 1.3133-3.8689 1.3222-1.4375 3.5583-1.4375 2.0054 0 3.1679 1.2956 1.1713 1.2867 1.1713 3.5051zm-1.6328-0.47917q-0.01775-1.3399-0.75426-2.1386-0.72764-0.79863-1.9345-0.79863-1.3665 0-2.1918 0.77201-0.81638 0.77201-0.94061 2.174z",
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m93.241 181.13h1.6328v13.807h-1.6328z",
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m105.43 185.38v1.5263q-0.69215-0.38157-1.3932-0.56792-0.69215-0.19522-1.402-0.19522-1.5884 0-2.4669 1.0116-0.8785 1.0027-0.8785 2.8218 0 1.8191 0.8785 2.8307 0.87849 1.0027 2.4669 1.0027 0.70989 0 1.402-0.18634 0.70102-0.19522 1.3932-0.57679v1.5085q-0.68328 0.31945-1.4198 0.47918-0.72764 0.15973-1.5529 0.15973-2.245 0-3.5672-1.4109-1.3222-1.4109-1.3222-3.8068 0-2.4314 1.3311-3.8246 1.3399-1.3932 3.6648-1.3932 0.75426 0 1.473 0.15972 0.71877 0.15086 1.3932 0.46143z",
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m112.14 186.15q-1.3133 0-2.0764 1.0294-0.76314 1.0205-0.76314 2.8041t0.75426 2.813q0.76314 1.0205 2.0853 1.0205 1.3044 0 2.0676-1.0293 0.76314-1.0294 0.76314-2.8041 0-1.7659-0.76314-2.7952-0.76314-1.0382-2.0676-1.0382zm0-1.3843q2.1297 0 3.3454 1.3843t1.2157 3.8334q0 2.4403-1.2157 3.8334-1.2157 1.3843-3.3454 1.3843-2.1386 0-3.3542-1.3843-1.2068-1.3932-1.2068-3.8334 0-2.4491 1.2068-3.8334 1.2157-1.3843 3.3542-1.3843z",
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m127.14 186.91q0.61228-1.1003 1.4642-1.6239 0.85187-0.52354 2.0054-0.52354 1.5529 0 2.3959 1.0915 0.843 1.0826 0.843 3.088v5.9986h-1.6416v-5.9454q0-1.4287-0.5058-2.1208-0.5058-0.69214-1.544-0.69214-1.2689 0-2.0054 0.84299-0.73652 0.843-0.73652 2.2983v5.617h-1.6416v-5.9454q0-1.4375-0.5058-2.1208-0.50579-0.69214-1.5618-0.69214-1.2512 0-1.9877 0.85187-0.73652 0.843-0.73652 2.2894v5.617h-1.6416v-9.9385h1.6416v1.544q0.55904-0.91399 1.3399-1.3488 0.78088-0.43481 1.8546-0.43481 1.0826 0 1.8368 0.55017 0.76314 0.55016 1.127 1.5973z",
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m145.61 189.56v0.79864h-7.5071q0.10648 1.686 1.0116 2.5734 0.91399 0.87849 2.5379 0.87849 0.94061 0 1.8191-0.23071 0.88737-0.23072 1.757-0.69215v1.544q-0.8785 0.37269-1.8014 0.56792-0.92286 0.19522-1.8723 0.19522-2.3782 0-3.7713-1.3843-1.3843-1.3843-1.3843-3.7447 0-2.4403 1.3133-3.8689 1.3222-1.4375 3.5583-1.4375 2.0054 0 3.1679 1.2956 1.1713 1.2867 1.1713 3.5051zm-1.6328-0.47917q-0.0178-1.3399-0.75426-2.1386-0.72764-0.79863-1.9345-0.79863-1.3666 0-2.1918 0.77201-0.81638 0.77201-0.94061 2.174z",
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxes);
export default __webpack_public_path__ + "static/media/boxes.489c6be4.svg";
export { ForwardRef as ReactComponent };